// assets/js/places-grid.js
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const isEditor = document.body.classList.contains("wp-admin");
if (!isEditor) gsap.registerPlugin(ScrollTrigger);

function initPlacesGrid(section) {
  if (!section || section.__pgInit) return;
  section.__pgInit = true;

  const eyebrow = section.querySelector(".places-grid__eyebrow");
  const title = section.querySelector(".places-grid__title");
  const intro = section.querySelector(".places-grid__intro");
  const cards = section.querySelectorAll(".places-grid__card");
  const footer = section.querySelector(".places-grid__footer");

  gsap.set([eyebrow, title, intro, footer], { opacity: 0, y: 18 });
  gsap.set(cards, { opacity: 0, y: 18 });

  const tlOpts = isEditor
    ? { defaults: { ease: "power3.out" } }
    : {
        defaults: { ease: "power3.out" },
        scrollTrigger: {
          trigger: section,
          start: "top 78%",
          once: true,
        },
      };

  const tl = gsap.timeline(tlOpts);

  if (eyebrow) tl.to(eyebrow, { opacity: 1, y: 0, duration: 0.45 });
  if (title) tl.to(title, { opacity: 1, y: 0, duration: 0.6 }, "-=0.2");
  if (intro) tl.to(intro, { opacity: 1, y: 0, duration: 0.5 }, "-=0.25");

  if (cards?.length) {
    tl.to(
      cards,
      {
        opacity: 1,
        y: 0,
        duration: 0.55,
        stagger: 0.08,
      },
      "-=0.15",
    );
  }

  if (footer) tl.to(footer, { opacity: 1, y: 0, duration: 0.45 }, "-=0.25");
}

const mount = () => {
  if (!isEditor) {
    document.querySelectorAll(".places-grid").forEach(initPlacesGrid);
    return;
  }

  const root = document.querySelector(".editor-styles-wrapper") || document;
  const run = () =>
    root.querySelectorAll(".places-grid").forEach(initPlacesGrid);

  run();
  const mo = new MutationObserver(run);
  mo.observe(root, { childList: true, subtree: true });
};

if (window.wp?.domReady) window.wp.domReady(mount);
else document.addEventListener("DOMContentLoaded", mount);
